<template>
	<div class="con">
		<div class="nav">
			<div class="nav-list" v-for="(item,index) in nav" @click="navBtn(item.id)">
				<div class="text" :class="[item.id == navIndex ? 'navActive':'']">{{item.text}}</div>
			</div>
		</div>
		<div class="time">
			<van-icon name="arrow-left" size="25px" :disabled="isDis" @click="onTime" />
			<div>{{choosTime}}</div>
			<van-icon name="arrow" size="25px" :disabled="isDis" @click="nextTime" />
		</div>
		<div class="list">
			<div class="list-head">
				<div class="list-head-men">
					<div>门诊</div>
					<div>{{outTotal}}</div>
				</div>
				<div class="total-monty">{{total}}</div>
				<div class="list-head-men">
					<div>住院</div>
					<div>{{InTotal}}</div>
				</div>
			</div>
			<!--<div v-for="item in list" class="list-con">
				<div class="list-title">{{item.text}}</div>
				<div v-for="cell in item.dataList">
					<div class="infosp" :class="[cell.id % 2 !== 0 ? 'infospActive':'']">
						<div>{{cell.text}}</div>
						<div>{{cell.num}}</div>
					</div>
				</div>
			</div>-->
			<!--门诊-->
			<div class="list-con">
				<div class="list-title">门诊</div>
				<div>
					<div class="infosp" >
						<div>最小处方价 </div>
						<div>{{outpatList.XMDJ_MIN}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>处方数量 </div>
						<div>{{outpatList.FY_SL}}</div>
					</div>
					<div class="infosp " >
						<div>平均处方价 </div>
						<div>{{outpatList.XMDJ_AVG}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>处方总金额 </div>
						<div>{{outpatList.ZJJE_SUM}}</div>
					</div>
					<div class="infosp" >
						<div>门诊人数 </div>
						<div>{{outpatList.OUTPAT_RS}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>出诊医生数 </div>
						<div>{{outpatList.YS_RS}}</div>
					</div>
					<div class="infosp" >
						<div>最大处方价 </div>
						<div>{{outpatList.XMDJ_MAX}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>药品金额 </div>
						<div>{{outpatList.YPZJE}}</div>
					</div>
					<div class="infosp" >
						<div>诊疗金额 </div>
						<div>{{outpatList.ZLZJE}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>材料金额 </div>
						<div>{{outpatList.CLZJE}}</div>
					</div>
					<div class="infosp" >
						<div>医保补偿 </div>
						<div>{{outpatList.YBBC}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>职工补偿 </div>
						<div>{{outpatList.ZGBC}}</div>
					</div>
					<div class="infosp" >
						<div>大病补偿 </div>
						<div>{{outpatList.DBBC}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>救助补偿 </div>
						<div>{{outpatList.JZBC}}</div>
					</div>
					<div class="infosp" >
						<div>兜底补偿 </div>
						<div>{{outpatList.DDBC}}</div>
					</div>
				</div>
			</div>
			<!--住院-->
			<div class="list-con">
				<div class="list-title">住院</div>
				<div>
					<div class="infosp" >
						<div>入院人数   </div>
						<div>{{InpatList.RYRS}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>出院人数 </div>
						<div>{{InpatList.CYRS}}</div>
					</div>
					<div class="infosp" >
						<div>在院人数   </div>
						<div>{{InpatList.ZYRS}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>在院危重病人数   </div>
						<div>{{InpatList.ZYWZRS}}</div>
					</div>
					<div class="infosp" >
						<div>总床位数   </div>
						<div>{{InpatList.ZCWS}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>已使用床位数   </div>
						<div>{{InpatList.SYCWS}}</div>
					</div>
					<div class="infosp" >
						<div>未使用床位数   </div>
						<div>{{InpatList.WSYCWS}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>药品金额   </div>
						<div>{{InpatList.YPZJE}}</div>
					</div>
					<div class="infosp" >
						<div>诊疗金额   </div>
						<div>{{InpatList.ZLZJE}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>材料金额   </div>
						<div>{{InpatList.CLZJE}}</div>
					</div>
					<div class="infosp" >
						<div>医保补偿   </div>
						<div>{{InpatList.YBBC}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>职工补偿   </div>
						<div>{{InpatList.ZGBC}}</div>
					</div>
					<div class="infosp" >
						<div>大病补偿   </div>
						<div>{{InpatList.DBBC}}</div>
					</div>
					<div class="infosp infospActive" >
						<div>救助补偿   </div>
						<div>{{InpatList.JZBC}}</div>
					</div>
					<div class="infosp" >
						<div>兜底补偿   </div>
						<div>{{InpatList.DDBC}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'staIndex',
		data() {
			return {
				List: [{
						id: 0,
						name: '住院',
						value: 100
					},
					{
						id: 1,
						name: '门诊',
						value: 144
					},
				],
				nav: [{
						id: 0,
						text: '年'
					},
					{
						id: 1,
						text: '月'
					},
					{
						id: 2,
						text: '日'
					},
				],
				navIndex: 0,
				choosTime: '', //显示的时间
				saveTimeYear: '',
				saveTimeMonth: '',
				saveTimeDay: '',
				isDis: true, //防止猛击按钮
				outpatList:{},
				InpatList:{},
				total:'',//总收入
				outTotal:'',
				InTotal:'',
			}
		},
		methods: {
			//门诊报表汇总
			GetList(){
				let time = this.choosTime;
				this.GetOutpatHzReport(time);
				this.GetInpatHzReport(time);
				
			},
			
			//门诊报表汇总
			GetOutpatHzReport(e){
				let time = e.split("-");
				
				if(time[1] == undefined){
					time[1] = '';
				}
				if(time[2] == undefined){
					time[2] = '';
				}
				this.$Axios.Get('/getOutpatHzReport?year='+time[0]+'&month='+time[1]+'&day='+time[2], null).then(res => {
					console.log(res)
					this.$store.commit('Load',false)
					if(res.code == 0){
						let datalist = res.msg;
						for(let i in datalist){
							if(i == 'XMDJ_AVG'){
								datalist.XMDJ_AVG = datalist.XMDJ_AVG.toFixed(2);
							}
						}
						this.outpatList = datalist;
						this.outTotal = datalist.ZJJE_SUM;
						this.total = Number(datalist.ZJJE_SUM + this.InTotal).toFixed(2);
					}
				}).catch(err => {
					this.$store.commit('Load',false)
					console.log(err)
				})
			},
			
			//住院报表汇总
			GetInpatHzReport(e){
				let time = e.split("-");
				
				if(time[1] == undefined){
					time[1] = '';
				}
				if(time[2] == undefined){
					time[2] = '';
				}
				this.$Axios.Get('/getInpatHzReport?year='+time[0]+'&month='+time[1]+'&day='+time[2], null).then(res => {
					console.log(res)
					this.$store.commit('Load',false)
					if(res.code == 0){
						this.InpatList = res.msg;
						this.InTotal = res.msg.ZLZJE;
					}
				}).catch(err => {
					this.$store.commit('Load',false)
					console.log(err)
				})
			},
			
			navBtn(e) {
				this.newText = this.nav[e].text;
				this.navIndex = e;
				let newT;
				switch(this.navIndex) {
					case 0:
						newT = this.$timeformat.timestampToTime(this.saveTimeYear);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0];
						break;
					case 1:
						newT = this.$timeformat.timestampToTime(this.saveTimeMonth);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0] + "-" + newT[1];
						break;
					case 2:
						newT = this.$timeformat.timestampToTime(this.saveTimeDay);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0] + "-" + newT[1] + "-" + newT[2];
						break;
				}
				this.GetList()
			},
			newTime() {
				let newT = this.$timeformat.timestampToTime(new Date());
				let newTime = newT.split(" ")[0];
				let timeSplit = newTime.split("-");
				this.choosTime = timeSplit[0];
				this.saveTimeYear = new Date().getTime();
				this.saveTimeMonth = new Date().getTime();
				this.saveTimeDay = new Date().getTime();
			},
			//上一个
			onTime() {
				let that = this;
				if(this.isDis == true) {
					switch(this.navIndex) {
						case 0:
							let countTimeYear = this.saveTimeYear - 1000 * 60 * 60 * 24 * 30 * 12;
							this.saveTimeYear = countTimeYear;
							let cTimeYear = this.$timeformat.timestampToTime(countTimeYear);
							cTimeYear = cTimeYear.split(" ")[0];
							cTimeYear = cTimeYear.split("-");
							this.choosTime = cTimeYear[0];
							break;
						case 1:
							let countTimeMoth = this.saveTimeMonth - 1000 * 60 * 60 * 24 * 30;
							this.saveTimeMonth = countTimeMoth;
							let cTimeMoth = this.$timeformat.timestampToTime(countTimeMoth);
							cTimeMoth = cTimeMoth.split(" ")[0];
							cTimeMoth = cTimeMoth.split("-");
							this.choosTime = cTimeMoth[0] + "-" + cTimeMoth[1]
							break;
						case 2:
							let countTimeDay = this.saveTimeDay - 1000 * 60 * 60 * 24;
							this.saveTimeDay = countTimeDay;
							let cTimeDay = this.$timeformat.timestampToTime(countTimeDay);
							cTimeDay = cTimeDay.split(" ")[0];
							this.choosTime = cTimeDay
							break;
					}
					this.isDis = false;
					setTimeout(() => {
						that.isDis = true;
					}, 500)
				}
				this.GetList()

			},
			//下一个
			nextTime() {
				let that = this;
				if(this.isDis == true) {
					switch(this.navIndex) {
						case 0:
							let countTimeYear = this.saveTimeYear + 1000 * 60 * 60 * 24 * 30 * 12;
							this.saveTimeYear = countTimeYear;
							let cTimeYear = this.$timeformat.timestampToTime(countTimeYear);
							cTimeYear = cTimeYear.split(" ")[0];
							cTimeYear = cTimeYear.split("-");
							this.choosTime = cTimeYear[0];
							break;
						case 1:
							let countTimeMoth = this.saveTimeMonth + 1000 * 60 * 60 * 24 * 30;
							this.saveTimeMonth = countTimeMoth;
							let cTimeMoth = this.$timeformat.timestampToTime(countTimeMoth);
							cTimeMoth = cTimeMoth.split(" ")[0];
							cTimeMoth = cTimeMoth.split("-");
							this.choosTime = cTimeMoth[0] + "-" + cTimeMoth[1]
							break;
						case 2:
							let countTimeDay = this.saveTimeDay + 1000 * 60 * 60 * 24;
							this.saveTimeDay = countTimeDay;
							let cTimeDay = this.$timeformat.timestampToTime(countTimeDay);
							cTimeDay = cTimeDay.split(" ")[0];
							this.choosTime = cTimeDay
							break;
					}
					this.isDis = false;
					setTimeout(() => {
						that.isDis = true;
					}, 500)
				}
				this.GetList()
			},
		
		},
		mounted() {
			this.newTime();
			this.GetList();

		},
		created() {},
	}
</script>

<style scoped>
	.con {
		width: 100%;
		height: 100%;
		background: #fff;
	}
	
	.nav {
		padding: 10px;
		display: flex;
		justify-content: center;
		background: #27BEC4
	}
	
	.nav-list {
		border: 1px solid #fff;
	}
	
	.text {
		padding: 10px 40px;
		color: #fff;
		font-size: 16px;
		text-align: center;
	}
	.navActive {
		background: #fff;
		color: #27BEC4;
	}
	
	.time {
		padding: 15px 0;
		display: flex;
		justify-content: space-around;
		align-content: center;
		font-size: 18px;
		background: #27BEC4;
		color:#fff;
	}
	
	
	.list-head {
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 10px 0;
		background: #27BEC4;
		width: 100%;
		color: #000;
	}
	
	.list {
		font-size: 15px;
		background-color: #fff;
	}
	
	.list-title {
		padding: 5px 0 5px 10px;
		margin: 10px;
		font-size: 18px;
		font-weight: 700;
		border-bottom: 1px solid #ccc;
	}
	
	.total-monty {
		width: 120px;
		height: 120px;
		line-height: 120px;
		border-radius: 50%;
		text-align: center;
		border: 3px solid #fff;
		color: #fff;
		font-size: 18px;
	}
	
	.list-head-men {
		margin-top: 50px;
		color: #fff;
		text-align: center;
	}
	
	.infosp {
		display: flex;
		justify-content: space-between;
		margin: 15px 20px;
	}
	.infospActive{
		background: #dcdcdc;
	}
</style>